module.exports = __webpack_public_path__ + "2f3b4e10.png";